import { Box, Divider, Stack, Typography } from '@mui/material'
import RobotDataBlock from 'components/Robot/RobotDataBlock'
import { useTranslation } from 'react-i18next'
import useUnitTelemetryStore from 'store/unitTelemetry'

import UnitMissionControl from './UnitMissionControl'
import UnitRobotsList from './UnitRobotsList'

const UnitDetails = () => {
  const telemetry = useUnitTelemetryStore(s => s.telemetry)
  const { t } = useTranslation()

  return (
    <Box
      height="100%"
      width="100%"
      display="grid"
      gridTemplateRows={{ xs: '370px 20px 75px 20px', sm: '165px 20px 75px 20px' }}
      gridTemplateColumns="100%"
    >
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} minHeight={{ sm: '110px' }}>
        <Box width={{ xs: '100%', sm: '50%' }}>
          <UnitMissionControl missionName={''} />
        </Box>
        <Box width={{ xs: '100%', sm: '25%' }}>
          <RobotDataBlock header={t('unitView.missionComplection')} value={2} tooltip="" />
        </Box>
        <Box width={{ xs: '100%', sm: '25%' }}>
          <RobotDataBlock header={t('unitView.timeLeft')} value="0" tooltip="" />
        </Box>
      </Stack>
      <Box paddingY={1}>
        <Divider />
      </Box>
      <Box>
        <Stack
          direction="row"
          justifyContent="space-between"
          bgcolor={'info.main'}
          p={2}
          borderRadius={4}
          maxHeight="45px"
        >
          <Box mr={1}>
            <Typography fontSize={{ xs: 12, sm: 14 }} mr={1}>
              {t('unitView.boxes')}
            </Typography>
            <Typography fontSize={{ xs: 12, sm: 14 }}>{telemetry.telemetry?.slots?.length ?? '-'}</Typography>
          </Box>
          <Box mr={1}>
            <Typography fontSize={{ xs: 12, sm: 14 }} mr={1}>
              {t('unitView.batteryCount')}
            </Typography>
            <Typography fontSize={{ xs: 12, sm: 14 }}>{telemetry.telemetry?.batteryCount ?? '-'}</Typography>
          </Box>
          <Box mr={1}>
            <Typography fontSize={{ xs: 12, sm: 14 }} mr={1}>
              {t('unitView.powerConsumption')}
            </Typography>
            <Typography fontSize={{ xs: 12, sm: 14 }}>
              {telemetry.telemetry?.powerConsumption?.toFixed(2) ?? '-'}
            </Typography>
          </Box>
          <Box>
            <Typography fontSize={{ xs: 12, sm: 14 }} mr={1}>
              {t('unitView.waterReserve')}
            </Typography>
            <Typography fontSize={{ xs: 12, sm: 14 }}>{telemetry.telemetry?.waterReserve?.toFixed() ?? '-'}</Typography>
          </Box>
        </Stack>
      </Box>
      <Box paddingY={1}>
        <Divider />
      </Box>
      <Box>
        <UnitRobotsList />
      </Box>
    </Box>
  )
}

export default UnitDetails
